import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { CustomerSurveyAnswer } from '@coin/shared/customer-survey/util';
import { CustomerSurveyComponent } from '../customer-survey/customer-survey.component';
import { CustomerSurveyQuestionComponent } from '../customer-survey-question/customer-survey-question.component';

@Component({
  selector: 'coin-customer-survey-answer',
  templateUrl: './customer-survey-answer.component.html',
  styleUrls: ['./customer-survey-answer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CustomerSurveyAnswerComponent {
  protected surveyComponent = inject(CustomerSurveyComponent);
  protected surveyQuestionComponent = inject(CustomerSurveyQuestionComponent);

  answer = input.required<CustomerSurveyAnswer>();
}
